import classNames from 'classnames'
import * as React from 'react'
import { AiOutlineArrowDown } from 'react-icons/ai'
import { pageTypeThemeCMYKVariantMapping } from '../../constants/theme.constants'
import { usePageState } from '../../layouts/page/page.context'
import BtnChangeLog from '../btn-changelog/btn-changelog.component'
import styleClasses from './landing-page-content.module.scss'

export type LandingPageContentProps = {
  icon?: any
  title?: string
  className?: string
  noArrow?: boolean
  useHeaderStyle?: boolean
  fullWidth?: boolean
}

const LandingPageContent: React.FC<LandingPageContentProps> = ({
  children,
  className,
  icon: Icon,
  title,
  noArrow,
  useHeaderStyle,
  fullWidth,
}) => {
  const { type } = usePageState()
  const variantClassName = type ? pageTypeThemeCMYKVariantMapping[type] : undefined
  return (
    <div
      className={classNames(
        className,
        variantClassName,
        useHeaderStyle ? styleClasses.container1 : styleClasses.container2,
        'landing-page-container', // referenced in page-layout
      )}
    >
      <BtnChangeLog />
      {Icon && <Icon className={styleClasses.icon} />}
      {title && <h1 className={styleClasses.heading}>{title}</h1>}
      {fullWidth ? children : <div className={styleClasses.content}>{children}</div>}
      {noArrow || (
        <div className={styleClasses.downArrow}>
          <AiOutlineArrowDown />
        </div>
      )}
    </div>
  )
}

export default LandingPageContent
